import React from "react";
import { FormikErrors, FormikHelpers, useField } from "formik";

// (modelOrCollection?: any, jqxhr?: JQueryXHR, options?: any) => void,
export function formErrorHandler<T>(
  msg: string,
  { setSubmitting, setFieldError }: FormikHelpers<T>
) {
  // type should be FormikConfig?
  return function (_model: any, response: JQueryXHR) {
    // form error
    setSubmitting(false);
    let result = JSON.parse(response.responseText);
    result = result && (result.parcel || result.error || result.error_message);
    if (typeof result === "string") {
      setFieldError("general", `${msg} ${result}`);
    } else {
      Object.keys(result || {}).forEach((key) => {
        const item = result[key];
        if (typeof item === "string" && item !== "__all__") {
          setFieldError(key, item);
        }
      });
      setFieldError("general", msg);
    }
  };
}

export function getGeneralError<T>(errors: FormikErrors<T>): string {
  // General error does not exists in FormikErrors. You cannot ensure it's there.
  // @ts-ignore
  return errors && errors.general;
}

export function withHidden(func: any) {
  return (props: any) => {
    if (props.type === "hidden") {
      const [field] = useField(props);
      return <input {...field} {...props} />;
    } else {
      return func(props);
    }
  };
}
